/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_TariffRateRequest } from './billing_TariffRateRequest';
export type billing_CreateTariffVersionRequest = {
    /**
     * AgeTransitionMonths is the BABY->CHILD threshold (months) for this version.
     * nil => inherit from the most recent ACTIVE version of the same group type (else default 24).
     */
    age_transition_months?: number;
    /**
     * AgeTransitionMonthsSubsidised is the threshold (months) used for subsidised contracts.
     * nil => inherit (else default 18).
     */
    age_transition_months_subsidised?: number;
    /**
     * AgeTransitionTiming controls when the transition takes effect (FOLLOWING_MONTH or ON_BIRTHDAY).
     * nil => inherit (else default FOLLOWING_MONTH).
     */
    age_transition_timing?: billing_CreateTariffVersionRequest.age_transition_timing;
    /**
     * BaseVersionID is the ID of an existing tariff version to copy rates from (optional)
     * If not provided, default rates will be created using the 8-combination matrix
     */
    base_version_id?: string;
    /**
     * Description of the tariff version
     */
    description?: string;
    /**
     * GroupType this tariff applies to (e.g., STANDARD) (required)
     */
    group_type: string;
    /**
     * IsDefault flag indicating if this is the default version for the group type
     */
    is_default?: boolean;
    /**
     * Name of the tariff version (required)
     */
    name: string;
    /**
     * Rates contains all the tariff rates for this version (optional)
     * If not provided, rates will be auto-created from BaseVersionID or as defaults
     */
    rates?: Array<billing_TariffRateRequest>;
    /**
     * RoundingParentsAmount is the parent-side rounding step in Rappen (>=1). nil => inherit (else default 5).
     */
    rounding_parents_amount?: number;
    /**
     * RoundingParentsEnabled toggles parent-side amount rounding for this version.
     * nil => inherit from the most recent ACTIVE version of the same group type (else default false).
     */
    rounding_parents_enabled?: boolean;
    /**
     * RoundingSubsidyAmount is the subsidy-side rounding step in Rappen (>=1). nil => inherit (else default 5).
     */
    rounding_subsidy_amount?: number;
    /**
     * RoundingSubsidyEnabled toggles subsidy-side amount rounding for this version.
     * nil => inherit (else default false).
     */
    rounding_subsidy_enabled?: boolean;
    /**
     * Status of the tariff version (DRAFT, ACTIVE, EXPIRED, ARCHIVED) (optional, defaults to DRAFT)
     */
    status?: billing_CreateTariffVersionRequest.status;
};
export namespace billing_CreateTariffVersionRequest {
    /**
     * AgeTransitionTiming controls when the transition takes effect (FOLLOWING_MONTH or ON_BIRTHDAY).
     * nil => inherit (else default FOLLOWING_MONTH).
     */
    export enum age_transition_timing {
        FOLLOWING_MONTH = 'FOLLOWING_MONTH',
        ON_BIRTHDAY = 'ON_BIRTHDAY',
    }
    /**
     * Status of the tariff version (DRAFT, ACTIVE, EXPIRED, ARCHIVED) (optional, defaults to DRAFT)
     */
    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        EXPIRED = 'EXPIRED',
        ARCHIVED = 'ARCHIVED',
    }
}

